import _ from 'underscore';
import Backbone from 'backbone';
import PrivacyContent from 'views/gdpr/privacy/PrivacyContent';
import Localizer from 'localizer';
import ViewerSocialProfile from 'models/user/ViewerSocialProfile';
import templateHtml from 'views/gdpr/privacy/templates/privacyView.html';

export default Backbone.View.extend({
    events: {
        'click .continue-button': 'onContinue'
    },

    template: _.template(templateHtml),
    tagName: 'div',

    render: function() {
        if (!ViewerSocialProfile.isUserLoggedIn()) {
            this.hideOverlay();
            return;
        }

        this.$el.html(
            this.template({
                Localizer: Localizer
            })
        );

        this.privacyContent = new PrivacyContent({
            el: this.$('.privacy-content-container')
        });

        this.listenTo(this.privacyContent, this.privacyContent.ALL_GRANTED, this.hideOverlay);
        this.listenTo(this.privacyContent, this.privacyContent.NOT_DISPLAYING, this.hideOverlay);
        this.listenTo(this.privacyContent, this.privacyContent.ENABLE_CONTINUE, this.consentChanged);
        this.listenTo(this.privacyContent, this.privacyContent.LOADED, this.showContent);
    },

    showContent: function() {
        this.$('.overlay-content').show();
    },

    hideOverlay: function() {
        $('.privacy-overlay').remove();
    },

    consentChanged: function(agreedToAll) {
        if (agreedToAll) {
            this.$('.continue-button').removeAttr('disabled');
        } else {
            this.$('.continue-button').attr('disabled', 'true');
        }
    },

    onContinue: function() {
        this.privacyContent.onContinue();
    }
});
